var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4249_1432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3787 13.7468C15.2101 13.9092 14.9847 14 14.7501 14C14.5155 14 14.2901 13.9092 14.1215 13.7468C12.5772 12.2504 10.5076 10.5788 11.5169 8.15187C12.0626 6.83966 13.3725 6 14.7501 6C16.1277 6 17.4376 6.83966 17.9833 8.15187C18.9913 10.5757 16.9268 12.2555 15.3787 13.7468Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 9.5H14.759",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 12C2.75 7.52166 2.75 5.28249 4.14124 3.89124C5.53249 2.5 7.77166 2.5 12.25 2.5C16.7283 2.5 18.9675 2.5 20.3588 3.89124C21.75 5.28249 21.75 7.52166 21.75 12C21.75 16.4783 21.75 18.7175 20.3588 20.1088C18.9675 21.5 16.7283 21.5 12.25 21.5C7.77166 21.5 5.53249 21.5 4.14124 20.1088C2.75 18.7175 2.75 16.4783 2.75 12Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 21L3.25 7",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14L4.25 20",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4249_1432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.44bb366e21bdf4a944fad401c3961142.svg";
export { ForwardRef as ReactComponent };